import React from 'react';

interface StackedBarSegment {
  label: string;
  value: number;
  percentage: number;
  color: string;
}

interface StackedBarProps {
  segments: StackedBarSegment[];
  total: number;
  totalLabel?: string;
  formatValue?: (value: number) => string;
}

const defaultFormat = (v: number) =>
  new Intl.NumberFormat('fr-CH', { maximumFractionDigits: 0 }).format(v);

export const StackedBar: React.FC<StackedBarProps> = ({
  segments,
  total,
  totalLabel = 'Total',
  formatValue = defaultFormat,
}) => {
  return (
    <div className="w-full">
      {/* Bar */}
      <div className="flex w-full h-6 rounded-full overflow-hidden">
        {segments.map((seg, i) => (
          <div
            key={i}
            className="h-full transition-all"
            style={{
              width: `${seg.percentage}%`,
              backgroundColor: seg.color,
            }}
          />
        ))}
      </div>

      {/* Total on the right */}
      <div className="flex justify-end mt-1">
        <span className="text-sm text-gray-500 dark:text-gray-400">{totalLabel}</span>
        <span className="text-sm font-bold text-gray-800 dark:text-gray-200 ml-2">
          {formatValue(total)} CHF
        </span>
      </div>

      {/* Legend */}
      <div className="flex flex-wrap gap-x-6 gap-y-2 mt-3">
        {segments.map((seg, i) => (
          <div key={i} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: seg.color }}
            />
            <div>
              <span className="text-sm text-gray-600 dark:text-gray-400">{seg.label}</span>
              <div className="flex items-baseline gap-1">
                <span className="text-sm font-semibold text-gray-800 dark:text-gray-200">
                  {formatValue(seg.value)} CHF
                </span>
                <span className="text-xs text-gray-400 dark:text-gray-500">
                  {seg.percentage.toFixed(1)}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
